// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"8c3ce7e4","207":"adbc3a3b","978":"14becaea"}[chunkId] + ".chunk.js";
};